export const addresses = {
  tokenGate: "0x0C8a3962a997E03BCd3648E3dEd068712D288c33",
};
